import { GetIsAlertsGeneratorBusyResp } from 'types/api/response/get-is-alerts-generator-busy-resp'

import { api } from './api'

export const checkIsAlertsGeneratorBusy = () =>
  api.get<GetIsAlertsGeneratorBusyResp>('/admin/alert_generators/is_busy')
